import React, { Fragment, Component } from "react";
import { accessRole } from "../../../../../helpers/access_role";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";
import Shimmer from "react-shimmer-effect";

import { Link, useHistory, Redirect } from "react-router-dom";
import { withRouter } from "react-router";

import apiResponse from "../../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";
import PegawaiSideBar from "../../../GlobalComponents/PegawaiSidebar";
import CustomSelect from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
  Preview,
} from "../../../../../helpers/ui/FileInput";

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

var reformatOptionsParents = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

var reformatOptionRegion = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

const jobType = [
  { value: 1, label: "PNS BKPM" },
  { value: 2, label: "PNS Non BKPM" },
  { value: 3, label: "Non PNS" },
  { value: 4, label: "Belum Bekerja" },
];

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear() + 10,
    years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};

class IndexView extends Component {
  updateBloc = new UpdateBloc();

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_uuid
      : "";
  peg_name = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_name
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_name
      : "";
  employee_current_position_name = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_current_position_name
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_current_position_name
      : "";
  peg_nip = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_nip
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_nip
      : "";

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      optionGender: [
        { label: "Laki-laki", value: "L" },
        { label: "Perempuan", value: "P" },
      ],
      optionStatus: [
        { label: "Kandung", value: "Kandung" },
        { label: "Angkat", value: "Angkat" },
        { label: "Tiri", value: "Tiri" },
      ],
      birthOptionNationality: [
        { label: "Dalam Negeri", value: "Dalam Negeri" },
        { label: "Luar Negeri", value: "Luar Negeri" },
      ],
      optionCollege: [
        { label: "Ya", value: 1 },
        { label: "Tidak", value: 0 },
      ],
      selectedGender: "",
      selectedStatus: "",
      optionParents: [],
      optionYears: createYearOption(new Date().getFullYear() - 20),
      birthOptionProvince: [],
      birthSelectedProvince: "",
      birthOptionCity: [],
      birthOptionCountry: [],
      birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
      birthSelectedParents: [],
      birthSelectedCity: "",
      birthSelectedNational: "",
      isLocal: 1,
      pnsStatus: 1,
      inCollege: 0,
      selectedDocType: null,
      selectedDocLabel: null,
      satkerGajiwebOption: [],
    };
  }

  // Select Area

  handleBirthSelectNationality = (birthSelectNationality) => {
    let selected = birthSelectNationality.value;
    if (selected == "Dalam Negeri") {
      this.setState({
        birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
        isLocal: 1,
      });
    } else {
      this.setState({
        birthSelectedCountry: "",
        isLocal: 0,
      });
    }
  };

  handleBirthSelectCountry = (birthSelectedCountry) => {
    let selected = birthSelectedCountry.value;
    this.getBirthProvinceByCountry(selected);
  };

  getBirthProvinceByCountry(selected_uuid) {
    this.updateBloc.fetchRegionProvince({
      //is_local: 1,
      parent_uuid: selected_uuid,
      type: 2,
    });
  }

  handleBirthSelectProvince = (birthSelectedProvince) => {
    this.setState({
      birthSelectedProvince: birthSelectedProvince.value,
    });

    this.updateBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: birthSelectedProvince.value,
    });
  };

  handleBirthSelectCity = (birthSelectedCity) => {
    this.setState({
      birthSelectedCity: birthSelectedCity.value,
    });
  };

  handleSelectGender = (selectedGender) => {
    this.setState({
      selectedGender: selectedGender.value,
    });
  };

  handleSelectStatus = (selectedStatus) => {
    this.setState({
      selectedStatus: selectedStatus.value,
    });
  };

  titleCase = (s) =>
    s.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
      c ? c.toUpperCase() : " " + d.toUpperCase(),
    );

  // End Select Area

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, "file_doc"); // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']

    await this.updateBloc.fetchUpdate(formData);
    // await this.updateBloc.fetchUpdate(this.state.dataForm)
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            console.log(response.family_spouse_divorce_number_decree);
            this.setState({
              dataForm: {
                family_uuid: response.family_uuid,
                employee_uuid: response.family_employee_uuid,
                place_of_birth_city_uuid:
                  response.family_place_of_birth_city_uuid,
                name: response.family_name,
                place_of_birth_city_text:
                  response.family_place_of_birth_city_text,
                date_of_birth: response.family_date_of_birth,
                gender: response.family_gender,
                profession: response.family_profession,
                identity_address: response.family_identity_address,
                identity_postal_code: response.family_identity_postal_code,
                phone_number: response.family_phone_number,
                place_of_birth_country_uuid:
                  response.family_place_of_birth_country_uuid,
                family_spouse_marriage_count:
                  response.family_spouse_marriage_count,
                family_spouse_divorce_number_decree:
                  response.family_spouse_divorce_number_decree,
                family_profession_pns_nip: response.family_profession_pns_nip,
                profession: response.family_profession,
                jobType: response.family_spouse_job_type,
                family_relationship_status_uuid:
                  response.family_relationship_status_uuid,
                family_is_currently_in_college:
                  response.family_is_currently_in_college,
                family_college_name: response.family_college_name,
                family_college_place: response.family_college_place,
                family_college_year_start: response.family_college_year_start,
                family_college_year_graduate:
                  response.family_college_year_graduate,
                family_college_document_uuid:
                  response.family_college_document_uuid,
                family_marital_status_uuid: response.family_marital_status_uuid,
                family_identity_number: response.family_identity_number,
                familty_family_card_number: response.familty_family_card_number,
              },
              selectedGender: response.family_gender,
              birthSelectedProvince:
                response.family_place_of_birth_province_uuid,
              birthSelectedCity: response.family_place_of_birth_city_uuid,
              birthSelectedCountry: response.family_place_of_birth_country_uuid,
              selectedStatus: response.family_child_status,
              birthSelectedParents:
                response.family_spouse_divorce_number_decree,
              birthSelectedNational: response.family_place_of_birth_national,
              pnsStatus: response.family_spouse_job_type,
              inCollege: response.family_is_currently_in_college,
              document_skk: response.document_skk,
              // document_akta_kel: response.document_akta_kel,
              documents: response.documents,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });

    // get data birth parents
    this.updateBloc.parentsChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              optionParents: reformatOptionsParents(
                response,
                "family_name",
                "family_name",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchParents({
      employee_uuid: this.peg_uuid,
    });

    // this.getBirthProvinceByParents(this.state.birthSelectedParents);

    // get data birth country
    this.updateBloc.regionCountryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCountry: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchRegionCountry({
      type: 1,
    });

    this.updateBloc.regionProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    // get data birth province
    this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

    this.updateBloc.fetchRegionProvince({
      is_local: 1,
      type: 2,
    });

    // get data city where province selected
    this.updateBloc.regionCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCity: reformatOptionRegion(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: this.state.birthSelectedProvince,
    });

    // get data relationship status
    this.updateBloc.relationshipStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              optionStatus: response.result,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchRelationshipStatus({
      relationship_uuid: "b01e17d8-b0c7-49b0-b601-a192064dfea1", // anak
    });

    // get data marital status
    this.updateBloc.maritalStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              optionMaritalStatus: response.result,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchMaritalStatus();

    this.updateBloc.satkerGajiWebChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const employeeData = result?.data?.response?.data?.decryptData?.[0];

          this.setState({
            satkerGajiwebOption: employeeData || {},
            loadingSatkerGajiWeb: false,
          });

          break;

        case apiResponse.ERROR:
          this.setState({
            loadingSatkerGajiWeb: false,
          });
          break;

        default:
          break;
      }
    });
    this.updateBloc.fetchSatkerGajiWeb({
      nip: this.peg_nip,
    });
  }

  componentWillUnmount() {
    this.updateBloc.updateChannel?.unsubscribe();
    this.updateBloc.detailChannel?.unsubscribe();
    this.updateBloc.parentsChannel.unsubscribe();
    this.updateBloc.regionCountryChannel?.unsubscribe();
    this.updateBloc.regionProvinceChannel?.unsubscribe();
    this.updateBloc.regionCityChannel?.unsubscribe();
    this.updateBloc.relationshipStatusChannel.unsubscribe();
    this.updateBloc.maritalStatusChannel.unsubscribe();
    this.updateBloc.satkerGajiWebChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="anak" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Edit Data Anak</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    {/* Masih HardCode */}
                    <AvField
                      name="family_uuid"
                      type="hidden"
                      id="family_uuid"
                      value={this.state.dataForm.family_uuid}
                    />
                    <AvField
                      name="employee_uuid"
                      type="hidden"
                      id="employee_uuid"
                      value={this.state.dataForm.employee_uuid}
                    />
                    {/* Sampai Sini */}

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Nama Anak<span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="name"
                          placeholder="Nama..."
                          type="text"
                          errorMessage="Masukkan Nama"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="name"
                          value={this.state.dataForm.name}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Nomor Induk Kependudukan
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="5">
                        <AvField
                          name="family_identity_number"
                          placeholder="Nomor Induk Kependudukan..."
                          type="text"
                          errorMessage="Masukkan Nomor Induk Kependudukan"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          id="family_identity_number"
                          value={this.state.dataForm.family_identity_number}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Nomor Kartu Keluarga
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Col md="4">
                        <AvField
                          name="familty_family_card_number"
                          placeholder="Nomor Kartu Keluarga..."
                          type="text"
                          errorMessage="Masukkan Nomor Kartu Keluarga"
                          className="form-control"
                          id="familty_family_card_number"
                          value={this.state.dataForm.familty_family_card_number}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="status"
                        className="col-md-3 col-form-label"
                      >
                        Status Anak <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="family_relationship_status_uuid"
                          errorMessage="Pilih Status Anak"
                          optionLabel="family_relationship_status_name"
                          optionValue="family_relationship_status_uuid"
                          options={this.state.optionStatus}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status Anak"
                          defaultValue={
                            this.state.dataForm.family_relationship_status_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="status"
                        className="col-md-3 col-form-label"
                      >
                        Status Perkawinan <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="family_marital_status_uuid"
                          errorMessage="Pilih Status Perkawinan"
                          optionLabel="marital_status_name"
                          optionValue="marital_status_uuid"
                          options={this.state.optionMaritalStatus}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status Perkawinan"
                          defaultValue={
                            this.state.dataForm.family_marital_status_uuid
                          }
                        />
                      </Col>
                    </Row>
                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="status"
                        className="col-md-3 col-form-label"
                      >
                        Sedang / Selesai Kuliah{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="family_is_currently_in_college"
                          errorMessage="Pilih Status"
                          options={this.state.optionCollege}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status"
                          onChange={(v) =>
                            this.setState({ inCollege: v.value })
                          }
                          defaultValue={this.state.inCollege}
                        />
                      </Col>
                    </Row>

                    {this.state.inCollege == 1 && (
                      <Fragment>
                        <Row className="mb-3">
                          <label
                            htmlFor="name"
                            className="col-md-3 col-form-label"
                          >
                            Nama Perguruan Tinggi
                            <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <AvField
                              name="family_college_name"
                              placeholder="Nama Perguruan Tinggi..."
                              type="text"
                              errorMessage="Masukkan Nama Perguruan Tinggi"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="family_college_name"
                              value={this.state.dataForm.family_college_name}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label
                            htmlFor="name"
                            className="col-md-3 col-form-label"
                          >
                            Alamat Perguruan Tinggi
                            <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <AvField
                              name="family_college_place"
                              placeholder="Alamat Perguruan Tinggi..."
                              type="text"
                              errorMessage="Masukkan Alamat Perguruan Tinggi"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="family_college_place"
                              value={this.state.dataForm.family_college_place}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label
                            htmlFor="name"
                            className="col-md-3 col-form-label"
                          >
                            Tahun Masuk<span className="text-danger">*</span>
                          </label>
                          <Col md="3">
                            <CustomSelect
                              name="family_college_year_start"
                              errorMessage="Pilih Tahun Masuk"
                              options={this.state.optionYears}
                              validate={{ required: { value: true } }}
                              placeholder="Pilih Tahun Masuk"
                              defaultValue={
                                this.state.dataForm.family_college_year_start
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label
                            htmlFor="name"
                            className="col-md-3 col-form-label"
                          >
                            Tahun Lulus (Jika sudah lulus)
                          </label>
                          <Col md="3">
                            <CustomSelect
                              name="family_college_year_graduate"
                              errorMessage="Pilih Tahun Lulus"
                              options={this.state.optionYears}
                              placeholder="Pilih Tahun Lulus"
                              defaultValue={
                                this.state.dataForm.family_college_year_graduate
                              }
                            />
                          </Col>
                        </Row>
                        {/* <Row className="mb-3">
                                                  <Label className="col-md-3 col-form-label">Upload Surat Keterangan Kuliah</Label>
                                                    <Col md="5">
                                                        <FileInput
                                                            name="file"
                                                        />
                                                        <div className="mt-2">
                                                            {
                                                                this.state.dataForm ?
                                                                    <>
                                                                        {this.state.document_skk !== null ?  
                                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document_skk?.documents_path}>
                                                                                Download <i className="fa fa-download ms-1"></i>
                                                                            </a>
                                                                        : ' '}
                                                                    </>
                                                                :
                                                                    <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>  */}
                      </Fragment>
                    )}

                    <hr />
                    <Row>
                      <Col md="5">
                        <label className="fw-bold">#Data Orang Tua</label>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Nama Orang Tua<span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="parent_name"
                          placeholder="Nama Orang Tua..."
                          type="text"
                          errorMessage="Masukkan Nama Orang Tua"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.peg_name}
                          disabled
                          id="parent_name"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Nama Pasangan<span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="wife_name"
                          errorMessage="Pilih Nama Pasangan"
                          options={this.state.optionParents}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Nama Pasangan"
                          defaultValue={this.state.birthSelectedParents}
                        />
                      </Col>
                    </Row>

                    <hr />
                    <Row>
                      <Col md="5">
                        <label className="fw-bold">#Tempat Lahir</label>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Dalam / Luar Negeri{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="place_of_birth_national"
                          errorMessage="Pilih Dalam / Luar Negeri Lahir"
                          onChange={this.handleBirthSelectNationality}
                          options={this.state.birthOptionNationality}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Dalam / Luar Negeri Lahir"
                          defaultValue={this.state.birthSelectedNational}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="tempat_lahir"
                        className="col-md-3 col-form-label"
                      >
                        Negara <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="place_of_birth_country_uuid"
                          errorMessage="Pilih Negara Lahir"
                          onChange={this.handleBirthSelectCountry}
                          options={this.state.birthOptionCountry}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Negara Lahir"
                          defaultValue={this.state.birthSelectedCountry}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 0 ? { display: "none" } : {}}
                    >
                      <label
                        htmlFor="tempat_ahir"
                        className="col-md-3 col-form-label"
                      >
                        Provinsi <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="birth_province_uuid"
                          errorMessage="Pilih Provinsi Lahir"
                          onChange={this.handleBirthSelectProvince}
                          options={this.state.birthOptionProvince}
                          validate={{
                            required: {
                              value: this.state.isLocal == 0 ? false : true,
                            },
                          }}
                          placeholder="Pilih Provinsi Lahir"
                          defaultValue={this.state.birthSelectedProvince}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 0 ? { display: "none" } : {}}
                    >
                      <label
                        htmlFor="tempat_ahir"
                        className="col-md-3 col-form-label"
                      >
                        Kota <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name="place_of_birth_city_uuid"
                          errorMessage="Pilih Kota Lahir"
                          options={this.state.birthOptionCity}
                          validate={{
                            required: {
                              value: this.state.isLocal == 0 ? false : true,
                            },
                          }}
                          placeholder="Pilih Kota Lahir"
                          defaultValue={
                            this.state.dataForm.place_of_birth_city_uuid
                          }
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 1 ? { display: "none" } : {}}
                    >
                      <label
                        htmlFor="place_of_birth_city_text"
                        className="col-md-3 col-form-label"
                      >
                        Kota <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="place_of_birth_city_text"
                          placeholder="Kota..."
                          type="text"
                          errorMessage="Masukkan Kota"
                          className="form-control"
                          validate={{
                            required: {
                              value: this.state.isLocal == 1 ? false : true,
                            },
                          }}
                          id="place_of_birth_city_text"
                          value={this.state.dataForm.place_of_birth_city_text}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="date_of_birth"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Lahir <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="date_of_birth"
                          placeholder="Tanggal Lahir..."
                          type="date"
                          errorMessage="Masukkan Tanggal Lahir"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="date_of_birth"
                          value={this.state.dataForm.date_of_birth}
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload Akta Kelahiran <span className="text-danger">*</span></Label>
                                            <Col md="5">
                                                <FileInput
                                                    name="file_akta"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.document_akta_kel !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document_akta_kel?.documents_path}>
                                                                        Download <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : ' '}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>  */}
                    <Row className="mb-3">
                      <label
                        htmlFor="gender"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Kelamin <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <Select
                          value={this.state.optionGender.filter(
                            (option) =>
                              option.value === this.state.selectedGender,
                          )}
                          onChange={this.handleSelectGender}
                          required="required"
                          options={this.state.optionGender}
                          classNamePrefix="select2-gender"
                        />

                        <AvField
                          name="gender"
                          type="hidden"
                          errorMessage="Pilih Jenis Kelamin"
                          validate={{ required: { value: true } }}
                          id="gender"
                          value={this.state.selectedGender}
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                                            <label
                                                htmlFor="profession"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pekerjaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="profession"
                                                    placeholder="Pekerjaan..."
                                                    type="text"
                                                    errorMessage="Masukkan Pekerjaan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="profession"
                                                    value={this.state.dataForm.profession}
                                                />
                                            </Col>
                                        </Row> */}
                    <Row className="mb-3">
                      <label
                        htmlFor="alamat"
                        className="col-md-3 col-form-label"
                      >
                        Alamat <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          name="identity_address"
                          placeholder="Alamat..."
                          type="textarea"
                          errorMessage="Masukkan Alamat"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="alamat"
                          value={this.state.dataForm.identity_address}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="identity_postal_code"
                        className="col-md-3 col-form-label"
                      >
                        Kode Pos <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="identity_postal_code"
                          placeholder="Kode Pos..."
                          type="number"
                          errorMessage="Masukkan Kode Pos"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="identity_postal_code"
                          value={this.state.dataForm.identity_postal_code}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="phone_number"
                        className="col-md-3 col-form-label"
                      >
                        Nomor Telepon <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="phone_number"
                          placeholder="Nomor Telepon..."
                          type="number"
                          errorMessage="Masukkan Nomor Telepon"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="phone_number"
                          value={this.state.dataForm.phone_number}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label
                        htmlFor="fieldJobType"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Pekerjaan : <span className="text-danger">*</span>
                      </Label>
                      <Col md="4">
                        <CustomSelect
                          name="jobType"
                          options={jobType}
                          isSearchable={false}
                          onChange={(opt) =>
                            this.setState({ pnsStatus: opt.value })
                          }
                          validate={{ required: { value: true } }}
                          defaultValue={this.state.dataForm.jobType}
                        />
                      </Col>
                    </Row>
                    {(this.state.pnsStatus === "1" ||
                      this.state.pnsStatus === "2") && (
                      <Row className="mb-3">
                        <Label
                          htmlFor="fieldNIP"
                          className="col-md-3 col-form-label"
                        >
                          NIP : <span className="text-danger">*</span>
                        </Label>
                        <Col md="4">
                          <AvField
                            name="nip"
                            placeholder="NIP..."
                            errorMessage="Masukkan NIP"
                            type="number"
                            className="form-control"
                            id="fieldNIP"
                            validate={{ required: { value: true } }}
                            value={
                              this.state.dataForm.family_profession_pns_nip
                            }
                          />
                        </Col>
                      </Row>
                    )}

                    {this.state.pnsStatus == 3 && (
                      <Row className="mb-3">
                        <label
                          htmlFor="profession"
                          className="col-md-3 col-form-label"
                        >
                          Pekerjaan <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                          <AvField
                            name="profession"
                            placeholder="Pekerjaan..."
                            type="text"
                            errorMessage="Masukkan Pekerjaan"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="profession"
                            value={this.state.dataForm.profession}
                          />
                        </Col>
                      </Row>
                    )}

                    <Row className="mb-3">
                      <label
                        htmlFor="status"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Dokumen <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="family_document_type"
                          errorMessage="Pilih Jenis Dokumen"
                          options={[
                            {
                              value: "file_akta_kelahiran",
                              label: "Akta Kelahiran",
                            },
                            {
                              value: "file_surat_kematian",
                              label: "Surat Kematian",
                            },
                            { value: "file_buku_nikah", label: "Buku Nikah" },
                            {
                              value: "file_surat_keterangan_kuliah",
                              label: "Surat Keterangan Kuliah",
                            },
                            {
                              value: "file_surat_keterangan_kerja",
                              label: "Surat Keterangan Kerja",
                            },
                            { value: "file_ijazah", label: "Ijazah" },
                          ]}
                          onChange={(v) => {
                            this.setState({
                              selectedDocType: v.value,
                              selectedDocLabel: v.label,
                            });
                          }}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Jenis Dokumen"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload Dokumen ({this.state.selectedDocLabel}){" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        <FileInput
                          name="file_doc"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <hr />

                    {this.state.documents?.map((val, i) => {
                      return (
                        <Row className="mb-3">
                          <label className="col-md-3">
                            {this.titleCase(val.family_document_type)}
                          </label>
                          <Col md="9">
                            {val.document ? (
                              <Preview value={val.document} />
                            ) : (
                              <Shimmer>
                                <div style={{ width: 68, height: 15 }}></div>
                              </Shimmer>
                            )}
                          </Col>
                        </Row>
                      );
                    })}

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <div className="form-check form-switch mb-3">
                          <AvCheckboxGroup
                            name="checkboxExample"
                            required
                            errorMessage="Agreement harus di centang"
                          >
                            <AvCheckbox
                              label="Saya yakin dan bertanggung jawab atas data ini"
                              value="1"
                            />
                          </AvCheckboxGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/home.html?anak">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>

                    <Row>
                      {/* <AvField
                        type="hidden"
                        name="employee_satker_code"
                        value={this.state.satkerGajiwebOption?.kdsatker}
                      /> */}
                      <AvField
                        type="hidden"
                        name="employee_nip"
                        value={this.peg_nip}
                      />
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/home.html?anak" />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
